module.exports = __webpack_public_path__ + "img/case-suggestions.48c417ac.png";